import React from 'react';
import { Table as AntTable } from 'antd';
import type { TableProps } from 'antd';



function TableData<T extends object = any>(props: TableProps<T>) {
  const { className, style, ...rest } = props;
  const mergedClassName = className ? `driveMynt-table ${className}` : 'driveMynt-table';
  return (
    <div className="driveMynt-table-wrap" style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0, ...style }}>
      <AntTable<T> className={mergedClassName} style={{ flex: 1 }} {...rest} />
    </div>
  );
}

export default TableData;
